/*
 * @license
 * Copyright 2017 Google LLC All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const config = {
  apiKey: "AIzaSyBL5wtWcxH7mGvEjftKsgkxT3bUATtUXZ0",
  authDomain: "sammansi-firebase.firebaseapp.com",
  projectId: "sammansi-firebase",
  storageBucket: "sammansi-firebase.firebasestorage.app",
  messagingSenderId: "251853289776",
  appId: "1:251853289776:web:7d5e762a0f91dcbc97b0f5"
};
